import {
  call, put, takeEvery,
} from 'redux-saga/effects';
import API from '../../api';
import { AsyncActionStatus } from '../enums';
import { generateErrorMessage } from '../helpers';
import { tableXlsxExport, toast } from '../../utilities';
import { RatingsActionTypes } from '../actions/types';
import { RatingsActionCreators, TableActionCreators } from '../actions/creators';
import { Table } from '../../views/components';
import projectsFeedbackTableAPI from '../../views/pages/ProjectsFeedback/projectsFeedbackTableAPI';

function* fetchRatingsByUserId(action) {
  try {
    const response = yield call(
      API.Ratings.getRatingsByUserId,
      action.payload.userId,
    );
    yield put(RatingsActionCreators.fetchRatingsByUserId[AsyncActionStatus.FULFILLED](
      response.data.ratings,
    ));
  } catch (error) {
    yield put(RatingsActionCreators.fetchRatingsByUserId[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
  }
}

function* addOrUpdateRating(action) {
  try {
    const response = yield call(
      API.Ratings.addOrUpdateRating,
      action.payload.rating,
    );
    yield put(RatingsActionCreators.addOrUpdateRating[AsyncActionStatus.FULFILLED](response.data));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(RatingsActionCreators.addOrUpdateRating[AsyncActionStatus.REJECTED](message));
    yield call(toast.error, message);
  }
}

function* changeRatingStatus(action) {
  try {
    const response = yield call(
      API.Ratings.changeRatingStatus,
      action.payload.ratingId,
    );
    yield put(RatingsActionCreators.changeRatingStatus[AsyncActionStatus.FULFILLED](response.data));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(RatingsActionCreators.changeRatingStatus[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
    yield call(toast.error, message);
  }
}

function* deleteRating(action) {
  try {
    const response = yield call(
      API.Ratings.deleteRating,
      action.payload.ratingId,
    );
    yield put(RatingsActionCreators.deleteRating[AsyncActionStatus.FULFILLED](response.data));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(RatingsActionCreators.deleteRating[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
    yield call(toast.error, message);
  }
}

function* getProjectsFeedbackData(action) {
  try {
    const response = yield call(
      API.Ratings.getProjectsFeedbackData,
      action.payload.filters,
      action.payload.pagination,
      action.payload.sortBy,
      action.payload.ratingTypes,
      action.payload.onlyByWriters,
    );

    if (action.payload.currentPath === window.location.pathname) {
      yield put(RatingsActionCreators.getProjectsFeedbackData[AsyncActionStatus.FULFILLED](response.data.ratings));
      yield put(TableActionCreators.setPagination({
        pageIndex: response.data.pageIndex,
        pageSize: response.data.pageSize,
        pageCount: response.data.pageCount,
        rowsTotalCount: response.data.rowsTotalCount,
      }));
      yield put(TableActionCreators.setSortBy(
        Table.convertSortByForTable(response.data.sortBy, projectsFeedbackTableAPI.columnsFixtures),
      ));
    } else {
      yield put(RatingsActionCreators.getProjectsFeedbackData[AsyncActionStatus.REJECTED]());
    }
  } catch (error) {
    yield put(RatingsActionCreators.getProjectsFeedbackData[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
  }
}

function* getProjectsFeedbackForExcel(action) {
  try {
    const {
      filters, sortBy, ratingTypes, tableAPI, onlyByWriters,
    } = action.payload;
    const response = yield call(
      API.Ratings.getProjectsFeedbackForExcel,
      filters,
      sortBy,
      ratingTypes,
      onlyByWriters,
    );
    tableXlsxExport(response.data.ratings, 'Project Feedback', tableAPI);
    yield put(RatingsActionCreators.getProjectsFeedbackForExcel[AsyncActionStatus.FULFILLED]());
  } catch (error) {
    yield put(RatingsActionCreators.getProjectsFeedbackForExcel[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
  }
}

export default [
  takeEvery(
    RatingsActionTypes.fetchRatingsByUserId[AsyncActionStatus.PENDING],
    fetchRatingsByUserId,
  ),
  takeEvery(
    RatingsActionTypes.addOrUpdateRating[AsyncActionStatus.PENDING],
    addOrUpdateRating,
  ),
  takeEvery(
    RatingsActionTypes.changeRatingStatus[AsyncActionStatus.PENDING],
    changeRatingStatus,
  ),
  takeEvery(
    RatingsActionTypes.deleteRating[AsyncActionStatus.PENDING],
    deleteRating,
  ),
  takeEvery(
    RatingsActionTypes.getProjectsFeedbackData[AsyncActionStatus.PENDING],
    getProjectsFeedbackData,
  ),
  takeEvery(
    RatingsActionTypes.getProjectsFeedbackForExcel[AsyncActionStatus.PENDING],
    getProjectsFeedbackForExcel,
  ),
];
